import _classCallCheck from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import ScaleContinuous, { deInterpolateLinear, copyScale } from './continuous';
import _ticks, { tickIncrement } from '../utils/array/ticks';
import interpolateNumber from '../utils/interpolators/number';
import { tickFormat as _tickFormat } from '../../../../fc-utils/src/array/ticks';

var ScaleLinear =
/*#__PURE__*/
function (_ScaleContinuous) {
  _inherits(ScaleLinear, _ScaleContinuous);

  function ScaleLinear() {
    _classCallCheck(this, ScaleLinear);

    return _possibleConstructorReturn(this, _getPrototypeOf(ScaleLinear).call(this, deInterpolateLinear, interpolateNumber));
  }

  _createClass(ScaleLinear, [{
    key: "ticks",
    value: function ticks() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 7;
      var b = this.getDomain();
      return this.majorTicks = _ticks(b[0], b[b.length - 1], a);
    }
  }, {
    key: "tickFormat",
    value: function tickFormat(a, b) {
      return _tickFormat(this.getDomain(), a, b, this._localeConverter);
    }
  }, {
    key: "nice",
    value: function nice() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 7;
      var b = Math.ceil,
          c = Math.floor;
      var d,
          e = this.getDomain(),
          f = 0,
          g = e.length - 1,
          h = e[f],
          i = e[g];
      return i < h && (d = h, h = i, i = d, d = f, f = g, g = d), d = tickIncrement(h, i, a), 0 < d ? (h = c(h / d) * d, i = b(i / d) * d, d = tickIncrement(h, i, a)) : 0 > d && (h = b(h * d) / d, i = c(i * d) / d, d = tickIncrement(h, i, a)), 0 < d ? (e[f] = c(h / d) * d, e[g] = b(i / d) * d, this.setDomain(e)) : 0 > d && (e[f] = b(h * d) / d, e[g] = c(i * d) / d, this.setDomain(e)), this;
    }
  }, {
    key: "copy",
    value: function copy() {
      return copyScale(this, new ScaleLinear());
    }
  }, {
    key: "minorTicks",
    value: function minorTicks() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 4;
      var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.majorTicks || this.ticks();
      var c,
          d,
          e,
          f,
          g = b.length,
          h = b[1] - b[0],
          k = [];

      for (f = 0; f < g - 1; ++f) {
        for (e = b[f], d = h / (+a + 1), c = 1; c <= a; c += 1) {
          k.push(e + d * c);
        }
      }

      return k;
    }
  }, {
    key: "contextTicks",
    value: function contextTicks() {
      return this.contextTicksArr || [];
    }
  }, {
    key: "getType",
    value: function getType() {
      return 'linear';
    }
  }]);

  return ScaleLinear;
}(ScaleContinuous);

export default ScaleLinear;